import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="px-4 py-8" data-id="element-73" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto max-w-3xl rounded-2xl border border-ink-line bg-ink-panel p-5 text-center" data-id="element-74" data-mp="1o2vg4lt3wh4z">
        <ShieldCheckIcon className="mx-auto h-9 w-9 text-gold" aria-hidden="true" data-id="element-75" data-mp="222whe2da9qkz" />
        <h2 className="mt-2 text-lg font-extrabold sm:text-2xl" data-id="element-76" data-mp="1x5d69bbvttx9">
          Your Investment Is 100% Protected
        </h2>
        <p className="mt-1 font-display text-sm font-bold uppercase text-gold sm:text-lg" data-id="element-77" data-mp="19fai36b3983x">
          🛡️ 7-Day Money-Back Guarantee
        </p>
        <div className="mt-2 space-y-1 text-sm leading-snug text-ink-text sm:text-base" data-id="element-78" data-mp="1j4agooloi1hl">
          <p data-id="element-79" data-mp="1edu416pomjwa">Explore the complete system for seven full days.</p>
          <p data-id="element-80" data-mp="1eciz33ki363l">
            Review every module. Use the therapy sessions. Print the resources. Organize your
            clinical work.
          </p>
          <p data-id="element-81" data-mp="lpogydb5oita">
            Experience how much preparation time this system can save every single week.
          </p>
          <p className="font-semibold text-white" data-id="element-82" data-mp="p0b5jqduz0db">
            If you're not completely satisfied, simply contact us within the first 7 days and
            we'll refund 100% of your purchase. No questions asked.
          </p>
        </div>
      </div>
    </section>;
}